import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { converter } from '../../helpers/converter';
import * as actions from '../../actions/response';

export class BtnFavorite extends React.Component {
  onClick(group) {
    const isFavorite =
      _.findIndex(this.props.favorites, { id: group.id }) != -1;
    const isFavoriteNew = !isFavorite;
    const { userhash } = this.props.user;

    if (isFavoriteNew) {
      this.props.onFavoriteAdd(group);
    } else {
      this.props.onFavoriteRemove(group);
    }

    this.props.onClick.bind({ group, userhash })(isFavorite);
  }

  render() {
    if (this.props.favorites == null) {
      return null;
    }

    const group = this.props.group;

    if (group.id == null) {
      group.id = group.group_id;
    }

    const isFavorite =
      _.findIndex(this.props.favorites, { id: group.id }) != -1;
    let label = converter.convertApaUnicode(
      this.props.translations,
      'btn_add_fav',
      'Por ver',
    );

    if (isFavorite) {
      label = converter.convertApaUnicode(
        this.props.translations,
        'btn_remove_fav',
        'Quitar',
      );
    }

    return (
      <div
        className="col-lg-12 col-md-12 col-sm-12 padding-top-1 padding-bottom-2"
        onClick={this.onClick.bind(this, group)}
      >
        <a
          href="#"
          role="button"
          className="btn btn-default item-fanbutton"
          {...this.props.btnProps}
        >
          {label}
        </a>
      </div>
    );
  }
}

BtnFavorite.propTypes = {
  group: PropTypes.object,
  translations: PropTypes.object,
  onClick: PropTypes.func,
  favorites: PropTypes.arrayOf(PropTypes.object),
  user: PropTypes.object,
  btnProps: PropTypes.object,
};

BtnFavorite.defaultProps = {
  btnProps: {},
};

const mapDispatchToProps = dispatch => ({
  onFavoriteAdd(group) {
    dispatch(actions.addFavorite(group));
  },
  onFavoriteRemove(group) {
    dispatch(actions.removeFavorite(group));
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(BtnFavorite);
